module.exports = __webpack_public_path__ + "media/components/outside-promo-page/static/skiers-2cb01cc9a43a85f4d9864b4719e51216.webp";